export default{
    tukeExplore: {
        accountChain: '계정 체인',
        bussnessChain: '비즈니스 체인',
        posChain: 'PoS 체인',
        enterTheThinkiumDAPPWebAddress: 'Dapp URL 입력',
        favorites: '즐겨찾기',
        noDappCollection: 'DApp을 즐겨찾기에 등록하지 않으셨습니다. 즐겨찾기로 이동하세요~',
        openDappAndCollect: 'DApp을 실행하고 오른쪽 상단의 [즐겨찾기]를 클릭합니다.',
        recommend: '추천',
        Organization: '조직',
        orgDesc: '조직에 가입',
        go:'가다',
    },
}